import cx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link, RelativeRoutingType, useLocation } from 'react-router-dom';
import '@app/index.scss';
import { SiteMap } from '@app/constants';

export type NavBarProps = {
  data: {
    name: string;
    link: string;
  }[];
  className?: string;
  listClassName?: string;
  itemClassName?: string;
  relative?: RelativeRoutingType;
};

export const NavBar = ({ data, className, listClassName, itemClassName, relative }: NavBarProps): JSX.Element => {
  const { t } = useTranslation();
  const location = useLocation();
  return (
    <nav className={cx(className, 'navbar')}>
      <ul className={cx(listClassName, 'navbar__list')}>
        {data.map((item) => {
          return (
            <li key={item.name} className="navbar__item">
              <Link
                to={item.link}
                relative={relative}
                className={cx(
                  itemClassName,
                  'navbar__link',
                  (item.link === SiteMap.ACCOUNT && location.pathname === item.link) ||
                    (item.link !== SiteMap.ACCOUNT && location.pathname.includes(item.link))
                    ? 'active'
                    : '',
                )}
              >
                {t(item.name)}
              </Link>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};
